// extracted by mini-css-extract-plugin
module.exports = {"playBtn":"play-button_playBtn__27pK1"};